import React from 'react';
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';

const NavCont = styled.nav`
  width: 100%;
  position: fixed;
  color: white;
  text-align: center;
  padding: 35px 0;
`;

const linkStyle = {
  color: "#363636",
  textDecoration: "none",
  margin: "0 4vw"
}

const activeStyle = {
  color: "#0062FF",
}
const navInfo = [
  {key: '1', link:'/', content:'Home'}, 
  {key: '2', link:'/works', content:'My Works'}, 
  {key: '3', link:'/about', content:'About Me'}, 
];

const navList = navInfo.map( item => (
  <NavLink key={item.key} exact to={item.link} style={linkStyle} activeStyle={activeStyle}>
    {item.content}
  </NavLink>
));

export default function TopAppBar() {
  return (
    <>
    <NavCont>
      {navList}     
    </NavCont>
    </>
  );
}
